import styled from 'styled-components'

export const CompanyDriveContainer = styled.div`
    padding: 16px;
    min-height: 200px;
`

export const CompanyDriveContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
`
